// --------------------------------------- Project List
import sdaia from '../images/SDAIA.png'
import NABA from '../images/Naba.png'
export const ProjectList = [{
  img: `${NABA}`,
  title: "NABA Platform (Notifications Gateway)",
  description:
    `
    
In the Notifications Gateway project for government sectors, I developed and enhanced a platform for sending SMS, email, and other notifications to individuals. I designed a service for generating detailed reports on message status and worked with MS SQL, Elasticsearch, and Kibana for dashboards. I also managed infrastructure, conducted functional testing, and continuously improved the application for high performance, gaining experience in database management, service development, and reporting mechanisms.`,
  tech_stack: "Elasticsearch, MS SQL, Java, Infrastucture",  
},{
    img: `${sdaia}`,
    title: "API Gateway",
    description:
      `In this project, I integrated government sectors using Software AG's API Gateway to manage over 60 services with SOAP and REST APIs. My role included overseeing API operations, configuring SSL certificates for secure connections, and closing variabilities (VAs) to enhance security and performance.`,
    tech_stack: "Web Services (API/SOAP), Servers",  
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641387741/PROJECTS/placex-location.herokuapp.com__mmqf5y.png",
    title: "PlaceX",
    description:
      "It's a website that help you to communicate with your friends ,and let you share posts with any place around you to let them know now places, such as: restaurant ,café , cinema ,etc..",
    tech_stack: "React, Node, Express, MongoDB (MERN Stack)",
    github_url: "https://github.com/Majeed99/PlaceX",
    demo_url: "https://placex-location.herokuapp.com/",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641388955/PROJECTS/fitnessappdemo.herokuapp.com__1_brxiiq.png",
    title: "Fitness Tracker",
    description:
      "In Fitness Tracker users can take fitness classes wherever and whenever they want. And every user have his own dashboard for his progress.",
    tech_stack: "React, Node, Express, MongoDB (MERN Stack)",
    github_url: "https://github.com/Majeed99/project-unit-2",
    demo_url: "https://fitnessappdemo.herokuapp.com/",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641403041/PROJECTS/screencapture-weatherapi-majeed99-netlify-app-2022-01-05-20_13_07_hrnuea.png",
    title: "Weather App",
    description:
      "In Weather App allows the user to find the weather status for any city around the world",
    tech_stack: "HTML, CSS, JavaScript ",
    github_url: "https://github.com/Majeed99/Project-unit-1",
    demo_url: "https://weatherapi-majeed99.netlify.app/",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/bootstrap.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641405690/PROJECTS/node_fj7giu.png",
    name: "Node",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641405897/PROJECTS/express-facebook-share_1_sdxdka.png",
    name: "Express",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641405607/PROJECTS/mongodb_fct23c.png",
    name: "MongoDB",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641405974/PROJECTS/api_cefx4a.png",
    name: "APIs",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641406104/PROJECTS/next_1_sh5doz.png",
    name: "NextJS",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641406144/PROJECTS/Tailwind_CSS_Logo.svg_zfibfe.png",
    name: "Tailwind",
  },
  // {
  //   img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641406241/PROJECTS/JSON-Web-Token-Authentication-With-Node_kipmx9.png",
  //   name: "JWT",
  // },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641406668/PROJECTS/redux_yz2jog.png",
    name: "Redux",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641406293/PROJECTS/figma_1_y9lcnf.png",
    name: "Figma",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641406746/PROJECTS/trello_vzwhcn.png",
    name: "Trello",
  },
  {
    img: "https://res.cloudinary.com/location-based-socail/image/upload/v1641405818/PROJECTS/heroku_zhvx4x.png",
    name: "Heroku",
  }, {
    img: "http://res.cloudinary.com/location-based-socail/image/upload/v1714601073/microsoft-sql-server_txwmud.png",
    name: "MS SQL",
  },
  {
    img: "http://res.cloudinary.com/location-based-socail/image/upload/v1714603118/elastic-kibana-logo_pevono.png",
    name: "Kibana",
  },
  
];
